export default __webpack_public_path__ + "static/media/back_arrow.0a412f8f.svg";